import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuiToastComponent } from '@ral/ui:aui/toast';
import { GclidComponent, GsapScrollToSegmentBasedOnNavigationComponent, injectWindowsDimensions } from '@ral/ui:gui';

@Component({
    imports: [RouterModule, GsapScrollToSegmentBasedOnNavigationComponent, GclidComponent, AuiToastComponent],
    selector: 'app-root',
    template: `
        <router-outlet />
        <!-- This component is used to scroll to a segment based on the navigation. -->
        <gsap-scroll-to-segment-based-on-navigation />
        <!-- This component is used to set the gclid cookie based on the navigation. -->
        <gsap-gclid />

        <aui-toast />
    `,
})
export class AppComponent {
    windowsDimensions = injectWindowsDimensions();
}
